import React, { useState, useEffect, FC } from "react";
import Card from "components/Card/Card";
import Const from "../../const.json";
import GroupButtons from "components/controls/GroupButtons/GroupButtons";
import { GetDistributionOfComplaints, GetNilonLevelsDropDownList } from "api/apiService";
import Table from "components/controls/Table/Table";
import { FirstCategoryEnum, MediaQuery } from "enums/enums";
import DropDown from "components/controls/DropDown/DropDown";
import { useAppSelector } from "../../redux/hooks";
import useMediaQuery from "hooks/useMediaQuery";
import ExportToExcel from "components/controls/ExportToExcel/ExportToExcel";
import { COMPLAINTS_LIMIT } from "utils/utils";
import useApi from "hooks/useApi";
import WithApi from "components/ui/WithApi/WithApi";
import { NilonLevelTableData, NilonLevelTableDataItem } from "types/NilonLevelTableTypes";

const DistributionOfComplaints: FC = () => {
  const { callApi, data, loading, error } = useApi<NilonLevelTableData>(GetDistributionOfComplaints);

  const [chosenCategoryIndex, setChosenCategoryIndex] = useState<number>(0);
  const [optionId, setOptionId] = useState<string>(null);
  const [rowsToExcel, setRowsToExcel] = useState<any>([]);
  const [headersToExcel, setHeadersToExcel] = useState<any>([]);
  const isMobile = useMediaQuery(MediaQuery.Mobile);

  const { period } = useAppSelector(state => state.general);

  useEffect(()=>{
    setOptionId(null);
    setChosenCategoryIndex(0);
    callApi();
  }, [period]);

  useEffect(() => {
    let _headers = [];
    if (data) {
      //headers of excel file
      _headers.push(Const.bodyType);
      Object.values(Const.levels).forEach(val => _headers.push(val));
      Object.values(Const.nilonLevelTableKeys).forEach((val, index) => index && _headers.push(val));

      //rows of excel file
      let _rows: any[] = [];
      let currentHierarchy: string[];
      let index: number;
      
      const processData = (data: NilonLevelTableDataItem[]) => {
        const setFirstLevel = (firstLevel: NilonLevelTableDataItem) => {
          currentHierarchy = Array(5).fill('');
          setLevel(firstLevel);
        }

        const setLevel = (row: NilonLevelTableDataItem) => {
          index = row.level;
          currentHierarchy[index] = row.description;
          setRows(row);
        }

        const setRows = (row: NilonLevelTableDataItem) => {
          let enumValue = getEnumKeyByValue(row.nilonCategoryId, FirstCategoryEnum);
          const newRow = [
            Const[enumValue],
            ...currentHierarchy
          ];
          Object.keys(Const.nilonLevelTableKeys).forEach((key, i) => {
            if (i) {
              if (!row[key])
                newRow.push('');
              else
                newRow.push(row[key])
            }
          });
          if (row.complaintCount >= COMPLAINTS_LIMIT) {
            _rows.push(newRow);
          }
        }

        data.forEach(firstLevel => {          
          setFirstLevel(firstLevel);
          firstLevel.children.forEach(row => {          
            if (index > row.level) {
              for (let i = row.level; i <= index; i ++) {
                currentHierarchy[i] = '';
              }
            }
            setLevel(row);
          });
        });
      }
      processData(data.data);
      setHeadersToExcel(_headers);
      setRowsToExcel(_rows);
    }
  }, [data]);

  const buttonDictionary = Object.keys(FirstCategoryEnum).map((fc) => {
    return {
      label: Const[`${fc.charAt(0).toLowerCase()}${fc.slice(1)}`],
      component: (
        <Table
          key={chosenCategoryIndex} 
          chosenCategoryIndex={chosenCategoryIndex}
          optionId={optionId}
        />
      ),
    };
  });


  // filters of the table
  const handleDropDownSelection = async (optionId?: string) => {
    setOptionId(optionId);
  };

  const exportToExcel = 
    <ExportToExcel 
      data={rowsToExcel} 
      filename={Const.tableOfDistributionByNilonLevels} 
      headers={headersToExcel} 
    />;


  return (
    <div className="DistributionOfComplaints">
      <Card
        components={!isMobile ? 
          [
            exportToExcel,
            <DropDown
              options={GetNilonLevelsDropDownList}
              title={Const.selectResponsibleBody}
              placeholder={Const.typeNameOfResponsibleBody}
              onSelect={handleDropDownSelection}
            />,
            <GroupButtons
              buttonNames={buttonDictionary}
              selectedIndex={chosenCategoryIndex}
              setCurrentIndex={setChosenCategoryIndex}
            />
          ] 
          :
          [<WithApi data={data} loading={loading} error={error}>{exportToExcel}</WithApi>]
        }
      />
    </div>
  );
};

export default DistributionOfComplaints;

const getEnumKeyByValue = (value: string, enumType: any): string | undefined => {
  const entry = Object.entries(enumType).find(([key, val]) => val === value);
  if (entry) {
    const [key] = entry;
    return key.charAt(0).toLowerCase() + key.slice(1);
  }
  return undefined;
}